<template>
  <ValidationProvider
    :name="$attrs.label"
    :rules="rules"
    v-slot="{ errors, touched, passed, untouched, failed, valid, invalid }"
  >
    <v-text-field v-model="innerValue" v-bind="$attrs" v-on="$listeners" filled>
      <template v-slot:append>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon :color="icon(touched, passed, untouched, failed, valid, invalid).color" v-on="on">
              {{ icon(touched, passed, untouched, failed, valid, invalid).icon }}
            </v-icon>
          </template>
          {{ showMessage(errors, passed) }}
        </v-tooltip>
      </template>
    </v-text-field>
    <div v-if="errorMessage" class="text-center">
      <span class="error-message font-weight-bold error--text fs-16">{{ errorMessage }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    value: {
      default: "",
      type: null
    },
    showIcons: {
      default: false,
      type: Boolean
    },
    showOnlyErrorIcons: {
      default: false,
      type: Boolean
    },
    errorMessage: {
      required: false,
      type: String
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    showMessage(errors, passed) {
      const labelName = this.$attrs && this.$attrs.label;
      return passed ? `Valid ${labelName}` : errors.find(i => i);
    },
    icon(touched, passed, untouched, failed, valid, invalid) {
      // showOnlyErrorIcons: failed | invalid
      if (this.showIcons) {
        if (untouched || touched) {
          if ((passed || valid) && !this.showOnlyErrorIcons) {
            return {
              color: "primary",
              icon: "fa-check-circle"
            };
          } else if (failed && invalid) {
            return {
              color: "error",
              icon: "fa-times-circle"
            };
          }
        }
        return "";
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss">
@import "../styles/settings/index";

.v-icon.fa-check-circle {
  color: $brand-primary !important;
}
.v-icon.fa-times-circle {
  color: $brand-danger !important;
}

// border-bottom color
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: inherit !important;
}

// text-field background and border
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  border: 2px solid $brand-grey !important;
  background-color: white !important;
}

// on text-field click, remove native focus, error/pass animation
.v-text-field > .v-input__control > .v-input__slot:after {
  border-color: none !important;
  border-style: none !important;
  border-width: 0 !important;
  -webkit-transform: none !important;
  transform: none !important;
}

.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding-right: 1em !important;
  padding-left: 0.2em !important;
}

// hide-details
.v-text-field__details {
  display: none !important;
}

.v-text-field--filled .v-label,
.v-text-field--full-width .v-label {
  font-size: 0.9em !important;
}

.v-text-field--filled .v-label--active,
.v-text-field--full-width .v-label--active {
  transform: translateY(-10px) scale(0.75);
}

// color change for label of input text field
.v-application--is-ltr .v-text-field .v-label {
  color: $secondary-text !important;
  font-weight: 600 !important;
}

// box shadow to all input text fields
.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.04) !important;
}

.v-text-field.v-text-field--enclosed.v-input--is-disabled > .v-input__control > .v-input__slot {
  background: lightgrey !important;
}
</style>
